export type View =
    | "overview"
    | "soc"
    | "ndr"
    | "mail"
    | "archive"
    | "downloads"
    | "ztna"
    | "phishing"
    | "pentests"
    | "soc-alert-detail"
    | "pentest-finding-detail"
    | "tickets"
    | "ticket-detail"
    | "chat"
    | "settings-notifications"
    | "settings-soc-exceptions"
    | "settings-profile"
    | "contracts"
    | "settings-approved-software";

export interface ViewContext {
    view: View;
    detailId?: string;
}

export type BadgeColor = "blue" | "cyan" | "purple" | "green" | "orange" | "red" | "zinc";

export const VIEW_LABELS: Record<string, string> = {
    overview: "OVERVIEW",
    soc: "SOC",
    ndr: "NDR",
    mail: "MAIL",
    ztna: "ZTNA",
    phishing: "PHISH",
    pentests: "PENTEST",
};

export const VIEW_COLORS: Record<string, BadgeColor> = {
    overview: "zinc",
    soc: "blue",
    ndr: "cyan",
    mail: "purple",
    ztna: "green",
    phishing: "orange",
    pentests: "red",
};

export const SYS_HEX: Record<string, string> = {
    soc: "#3b82f6",
    ndr: "#06b6d4",
    mail: "#a855f7",
    ztna: "#22c55e",
    phishing: "#f97316",
    pentests: "#ef4444",
};

export type SystemView = "soc" | "ndr" | "mail" | "ztna" | "phishing" | "pentests";

export const SYSTEM_LIST: SystemView[] = ["soc", "ndr", "mail", "ztna", "phishing", "pentests"];
